import Hero from './Hero';

export { default as HeroTheme } from './Hero.style';
export default Hero;
